import { apiClient } from '@/plugins/api'

export default {
  sendMail(payload, category = {"main": "student_caring", "sub": "Users Status"}) {
    payload.messageCategory = category
    return apiClient.post('/email', payload)
  },
  testSmtpMailConfig(companyId, payload){
    return apiClient.post(`/email/company/${companyId}/test`, payload)
  },
  exportMailLogs(companyId, category, lang, filetype){
    const opt = {
      responseType: 'blob' ,
      params: {
        companyId: companyId,
        category: category,
        lang: lang,
        filetype: filetype,
      }
    }
    return apiClient.get(`/email/logs/export`, opt);
  },
  getCompanyEmailStats(companyId){
    return apiClient.get(`/email/company/${companyId}/stats`)
  },
  getAllEmailStats(companyId) {
    const params = companyId ? { companyId } : undefined
    return apiClient.get(`/email/stats`, { params })
  },
}
